import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { Order } from '../../models';
import OrderInfoDetail from '../../order-info.interface';

@Component({
  selector: 'app-extended-row',
  templateUrl: './extended-row.component.html',
  standalone: false,
})
export class ExtendedRowComponent implements OnInit {
  @Output() openOrder = new EventEmitter<Order>();

  @Input() order: Order;

  public info: OrderInfoDetail[] = null;

  public title: string = '...';

  ngOnInit(): void {
    this.setTitle();
    this.getCustomInfo();
  }

  private setTitle(): void {
    this.title = this.order.getService();
    this.title += ' Order Detail';
  }

  private getCustomInfo(): void {
    this.info = this.order.getRowInfo();
  }

  public viewMore(): void {
    this.openOrder.emit(this.order);
  }
}
